import React, { useState } from "react";
import { Handle, Position } from "react-flow-renderer";

//Rack (capa física): un cuadrado que se dibuja libremente en el lienzo, se puede pegar uno junto a otro,
//y se vincula a uno o varios nodos de la capa de circulación arrastrando una conexión desde cualquiera de
//sus 4 lados (los Handle de aquí) hacia un nodo "punto" - esa liga NO es un tramo caminable, ver
//MapaAlmacenEditor.js/onConnect. No usa NodeResizer (no existe en react-flow-renderer 10.x, ver
//SeccionCanvas.js) - el resize se hace a mano igual que ahí.
const RackCanvas = ({ data, selected }) => {
  const [tamanoPreview, setTamanoPreview] = useState(null);
  const ancho = tamanoPreview?.width ?? data.anchoActual ?? 70;
  const alto = tamanoPreview?.height ?? data.altoActual ?? 70;
  const vinculado = (data.nodosAccesoIds || []).length > 0;
  const esDestino = data.esRackDestino;
  const esResaltadoBusqueda = data.esResaltadoBusqueda;

  const iniciarResize = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const inicioX = event.clientX;
    const inicioY = event.clientY;
    const anchoInicial = data.anchoActual ?? 70;
    const altoInicial = data.altoActual ?? 70;

    const mover = (moveEvent) => {
      setTamanoPreview({
        width: Math.max(40, anchoInicial + (moveEvent.clientX - inicioX)),
        height: Math.max(40, altoInicial + (moveEvent.clientY - inicioY)),
      });
    };
    const soltar = (upEvent) => {
      const nuevoAncho = Math.max(40, anchoInicial + (upEvent.clientX - inicioX));
      const nuevoAlto = Math.max(40, altoInicial + (upEvent.clientY - inicioY));
      document.removeEventListener("mousemove", mover);
      document.removeEventListener("mouseup", soltar);
      setTamanoPreview(null);
      data.onResize && data.onResize({ width: nuevoAncho, height: nuevoAlto });
    };
    document.addEventListener("mousemove", mover);
    document.addEventListener("mouseup", soltar);
  };

  return (
    <div
      style={{
        width: ancho,
        height: alto,
        background: esDestino ? "#f9731633" : esResaltadoBusqueda ? "#8b5cf622" : vinculado ? "#BF8D6F22" : "#ef444422",
        border: `${esDestino || esResaltadoBusqueda ? 3 : 2}px solid ${esDestino ? "#f97316" : esResaltadoBusqueda ? "#8b5cf6" : selected ? "#BF8D6F" : vinculado ? "#BF8D6F88" : "#ef444488"}`,
        borderRadius: 4,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        boxSizing: "border-box",
        boxShadow: esDestino ? "0 0 0 5px #f9731633" : esResaltadoBusqueda ? "0 0 0 5px #8b5cf633" : undefined,
      }}
      title={data.esRackDestino ? `Rack ${data.codigo} - ve aquí` : data.esResaltadoBusqueda ? `Rack ${data.codigo} - contiene el insumo buscado` : vinculado ? `Rack ${data.codigo}` : `Rack ${data.codigo} (sin vincular a ningún pasillo)`}
    >
      <Handle type="source" position={Position.Top} id="top" style={{ background: "#BF8D6F" }} />
      <Handle type="target" position={Position.Top} id="top-target" style={{ background: "#BF8D6F" }} />
      <Handle type="source" position={Position.Right} id="right" style={{ background: "#BF8D6F" }} />
      <Handle type="target" position={Position.Right} id="right-target" style={{ background: "#BF8D6F" }} />
      <Handle type="source" position={Position.Bottom} id="bottom" style={{ background: "#BF8D6F" }} />
      <Handle type="target" position={Position.Bottom} id="bottom-target" style={{ background: "#BF8D6F" }} />
      <Handle type="source" position={Position.Left} id="left" style={{ background: "#BF8D6F" }} />
      <Handle type="target" position={Position.Left} id="left-target" style={{ background: "#BF8D6F" }} />

      <div style={{ fontSize: 10, fontWeight: 700, color: "#6b4a35" }}>{data.codigo}</div>
      {data.totalUbicaciones > 0 && (
        <div style={{ fontSize: 9, color: "#8a6d00" }}>{data.totalUbicaciones} ub.</div>
      )}

      {selected && (
        <div
          className="nodrag"
          onMouseDown={iniciarResize}
          style={{
            position: "absolute",
            right: 0,
            bottom: 0,
            width: 10,
            height: 10,
            cursor: "nwse-resize",
            background: "#BF8D6F",
          }}
        />
      )}
    </div>
  );
};

export default RackCanvas;
